import React from 'react';

import Modal from 'antd/es/modal/Modal';

import PetMemorialGallery from '@app/components/Pages/PetMemorial/PetMemorialModalGallery';
import listenerForBrowser from '@app/components/Pages/listenerForBrowser';
import NavSelectMobile from '@app/components/UI/NavSelectMobile/NavSelectMobile';
import { TesAuthorCredits } from '@app/components/UI/VetTesCard/VetTesCard';
import '@app/scss/components/vetTesModal.scss';
import { useIsMobile } from '@app/hooks/useIsMobile';

interface PetMemorialPreviewModalProps {
	memorial: Partial<any>;
	modalVisible: boolean;
	setModalVisible: (bool: boolean) => void;
}

const candleImg = require('@images/link-icons/candle.svg');

const getDate = (date: number | null) => {
	if (typeof date === 'number') {
		return new Date(date).toLocaleDateString('en-US', { timeZone: 'UTC' });
	}

	return '-/-';
};

const PetMemorialPreviewModal: React.FC<PetMemorialPreviewModalProps> = ({ modalVisible, setModalVisible, memorial }) => {
	const navItems = [
		{ name: 'memory', title: `In loving memory of ${memorial.petName ? memorial.petName : 'your pet'}` },
		{ name: 'about', title: `${memorial.petName ? memorial.petName : 'your pet'}'s Story` },
	];

	const [currentIndex, setCurrentIndex] = React.useState(0);
	const currentIssue = navItems[currentIndex].name;
	const navCollapse = useIsMobile();

	const onSetIssue = (index) => {
		let num = index;

		if (navCollapse) {
			navItems.forEach((item, i: number) => {
				if (item.title === index) {
					num = i;
				}
			});
		}

		setCurrentIndex(num);
	};

	const modalProps = memorial.images ? { memorial: { images: memorial.images } } : '';

	return (
		<Modal
			wrapClassName="modal-wrap pet-mem-preview-modal"
			open={modalVisible}
			onOk={() => setModalVisible(false)}
			onCancel={() => setModalVisible(false)}
			width={1037}
			centered
		>
			{memorial && (
				<div className="pet-mem-modal__content">
					<div className="pet-mem-modal__container">
						<header className="pet-mem-modal__content-header">
							<div className="pet-mem-modal__content-header-title">
								<h4>{memorial.petName}</h4>
								<div>
									<span>{getDate(memorial.dateBirth)}</span>
									<span> - </span>
									<span>{getDate(memorial.datePass)}</span>
								</div>
							</div>
							<div className="pet-mem-modal__content-header-nav">
								{memorial.memorialCandles?.length > 0 && (
									<div className="pet-mem-modal__content-header-candle">
										<img src={candleImg} alt="candle" />
										<span>{memorial.memorialCandles.length}</span>
									</div>
								)}
							</div>
						</header>
						<PetMemorialGallery navCollapse={navCollapse} modalProps={modalProps} />
						{navCollapse ? (
							<div className="nav-select-mobile__wrapper">
								<button className="btn btn-primary" onClick={() => {}}>
									Light a candle
								</button>
								<NavSelectMobile navItems={navItems} onChange={onSetIssue} currentIndex={currentIndex} />
							</div>
						) : (
							<div className="pet-mem-modal__content-nav">
								{navItems && (
									navItems.map((item, index) => (
										<button
											key={index}
											className={
												currentIndex === index
													? 'pet-mem-modal__content-nav-button active'
													: 'pet-mem-modal__content-nav-button'
											}
											onClick={() => onSetIssue(index)}
										>
											{item.title}
										</button>
									))
								)}
							</div>
						)}
						<div className="pet-mem-modal__content-issues">
							<div className="pet-mem-modal__content-topic">
								{currentIssue === 'memory' ? <p>{memorial.message}</p> : <p>{memorial.story}</p>}
							</div>
							<TesAuthorCredits
								firstName={memorial.firstName}
								lastName={memorial.lastName}
								city={memorial.city}
								state={memorial.state}
								date={memorial.datePost}
								isShowName={memorial.isShowName}
							/>
						</div>
					</div>
				</div>
			)}
		</Modal>
	);
};

export default PetMemorialPreviewModal;
